<template>
  <el-dialog width="600px" title="批量修改订单状态" v-model="isvisible">
    <el-form
      ref="orderFormRef"
      :model="orderForm"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="订单状态" prop="orderstatus">
        <el-select
          v-model="orderForm.orderstatus"
          placeholder="选择订单状态"
          style="width: 100%"
        >
        <el-option label="待发货" :value="1" />
        <el-option label="备货中" :value="2" />
        <el-option label="发货失败" :value="3" />
        <el-option label="已发货" :value="4" />
        <el-option label="发货完结" :value="5" />
        <el-option label="已取消" :value="6" />
        </el-select>
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
        <el-button type="danger" @click="doBatchSaveOrderStatus" :loading="loading" >{{
          loading ? "提交中 ..." : "确认"
        }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>
  <script setup>
import { ref, defineExpose, defineEmits } from "vue";
import { ElMessage } from "element-plus";
import { batchSaveOrderStatus } from "@/api/order";

let timer;

const loading = ref(false);

const emit = defineEmits(["click"]); // 声明父触发事件


const isvisible = ref(false);
const changeVisible = (v) => {
  isvisible.value = v;
};

const orderFormRef = ref();
const orderForm = ref({
  orderid: "",
  orderstatus: "",
});

const orderStatusMethod = (obj) => {
  orderForm.value = {
    orderid: obj.orderid,
  };
  // console.log("orderForm.value---", orderForm.value);

};

defineExpose({ changeVisible, orderStatusMethod });

const doBatchSaveOrderStatus = () => {
  orderFormRef.value.validate((valid) => {
    if (!valid) {
      // ElMessage("请先完善表单数据填写！");
      return;
    }

    let orders = [];
    let orderids = orderForm.value.orderid;

    for (let i = 0; i < orderids.length; i++) {
      orders.push({
        orderid: orderids[i],
        orderstatus: orderForm.value.orderstatus,
      });
    }
    // console.log("orders---", orders);
    // console.log("orderForm.value---", orderForm.value);

    batchSaveOrderStatus(orders).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          closeDialog();
          emit("click");
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

const closeDialog = () => {
  isvisible.value = false;
  orderFormRef.value.resetFields();
  clearTimeout(timer);
};

//表单验证规则
const rules = ref({
  orderstatus: [
    {
      required: true,
      message: "请选择订单状态",
      trigger: "change",
    }
  ]
});
</script>
  <style scoped>
.el-dialog {
  text-align: left;
}
.el-dialog__body {
  padding-top: 15px;
}
</style>